import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPagination = (state) => get(state, 'notifications_config.list.pagination', {});
export const getFilters = (state) => get(state, 'notifications_config.list.filters', {});

export const getNotificationsConfigIds = (state) =>
  get(state, 'notifications_config.list.result.notification_config', []);
export const getNotificationsConfig = (state) =>
  get(state, 'notifications_config.list.entities.notification_config', {});

export const getIsLoading = (state) => get(state, 'notifications_config.list.isLoading', false);
export const getNeedFetch = (state) => get(state, 'notifications_config.list.needFetch', false);

export const getIsFetching = (state) => get(state, 'notifications_config.form.isFetching', false);
export const getIsFetchingConfig = (state) =>
  get(state, 'notifications_config.form.isFetchingConfig', false);
export const getIsSaving = (state) => get(state, 'notifications_config.form.isSaving', false);
export const getEditing = (state) => get(state, 'notifications_config.form.editing', false);

export const getVisibleNotificationsConfig = createSelector(
  [getNotificationsConfigIds, getNotificationsConfig],
  (ids, notifications_config) =>
    ids
      .map((id) => notifications_config[id])
      .filter((notificationConfig) => !notificationConfig.deleted)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/selectors/notifications_config_selectors.js